<template>
    <div class="footer-content">
        <div class="footer-content-top">
            <div class="footer-content-top-logo">
                <router-link to="/">
                    <img v-if="appparams.logo" :src="getUrl(appparams.logo)" class="img-block" alt="" />
                </router-link>
                <div class="footer-logo-bottom">
                    <div class="footer-qrcode">
                        <img v-if="appparams.qrcode" :src="getUrl(appparams.qrcode)" alt="微信公众号二维码" />
                    </div>
                    <div class="footer-contact-info">
                        <div class="footer-text">
                            <i class="el-icon-phone"></i>
                            <span style="margin-left: 5px;">{{ appparams.phone }}</span>
                        </div>
                        <div class="footer-text" v-if="emailData">
                            <i class="el-icon-message"></i>
                            <span style="margin-left: 5px;">{{ emailData }}</span>
                        </div>
                        <div class="footer-text">
                            <i class="el-icon-map-location"></i>
                            <span style="margin-left: 5px;">{{ appparams.address }}</span>
                        </div>
                    </div>
                </div>
                <!-- 桌面端版权信息 -->
                <div class="footer-content-bottom" v-if="!isMobile">
                    <div class="footer-copyright">
                        <p>{{ appparams.copyright }}</p>
                    </div>
                </div>
            </div>
            <div class="footer-content-top-nav">
                <!-- 桌面端：普通列表 -->
                <template v-if="!isMobile">
                    <ul v-for="menu in footerMenus" :key="menu.index">
                        <a @click="handleMenuClick(menu)" class="f1">{{ menu.title }}</a>
                        <li v-if="menu.children && menu.children.length">
                            <a v-for="child in menu.children" :key="child.index" @click="handleMenuClick(child)">
                                {{ child.title }}
                            </a>
                        </li>
                    </ul>
                </template>

                <!-- 移动端：手风琴折叠面板 -->
                <el-collapse v-if="isMobile" v-model="activeMenu" accordion class="footer-collapse">
                    <el-collapse-item v-for="menu in footerMenus" :key="menu.index" :name="menu.index"
                        :disabled="!menu.children || !menu.children.length">
                        <template slot="title">
                            <span @click="handleMobileMenuClick(menu, $event)" class="menu-title">
                                {{ menu.title }}
                            </span>
                        </template>
                        <div v-if="menu.children && menu.children.length" class="submenu-list">
                            <a v-for="child in menu.children" :key="child.index" @click="handleMenuClick(child)"
                                class="submenu-item">
                                {{ child.title }}
                            </a>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <!-- 移动端版权信息 -->
        <div class="footer-content-bottom-mobile" v-if="isMobile">
            <div class="footer-copyright">
                <p>{{ appparams.copyright }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import appmanagerapi from '@/api/AppManager'
import commonapi from '@/api/common'
import aboutmanagerapi from '@/api/AboutManager'
export default {
    name: 'SiteFooter',
    data() {
        return {
            imageUrlCache: {}, // 图片URL缓存
            appparams: {},
            isMobile: window.innerWidth <= 768,
            emailData: '', // 邮箱数据
            activeMenu: '' // el-collapse 当前激活的菜单
        }
    },
    computed: {
        footerMenus() {
            // 过滤掉第一个（首页）
            let menus = this.appparams.menu_list ? this.appparams.menu_list.slice(1) : [];
            // 替换菜单标题
            return menus.map(menu => {
                let newTitle = menu.title;
                if (newTitle === '方案') newTitle = '解决方案';
                if (newTitle === '产品') newTitle = '产品中心';
                if (newTitle === '关于') newTitle = '关于我们';
                if (newTitle === '媒体') newTitle = '媒体中心';
                return { ...menu, title: newTitle };
            });
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.isMobile = window.innerWidth <= 768;
        },
        // 处理移动端菜单点击事件
        handleMobileMenuClick(menu, event) {
            // 如果菜单没有子菜单，跳转到对应页面
            if (!menu.children || !menu.children.length) {
                event.stopPropagation(); // 阻止 el-collapse 的默认行为
                this.handleMenuClick(menu);
            }
            // 如果有子菜单，不做任何处理，让 el-collapse 自己处理展开
        },
        // 处理菜单点击事件
        handleMenuClick(menuItem) {
            // 处理首页导航
            if (menuItem.path === '/') {
                // 如果当前不在主页，先跳转到主页
                if (this.$route.path !== '/') {
                    this.$router.push('/').catch(err => {
                        // 忽略重复导航错误
                        if (err.name !== 'NavigationDuplicated') {
                            console.error('路由跳转失败:', err);
                        }
                    });
                } else {
                    // 如果已经在主页，滚动到第一屏
                    this.scrollToFirstSection();
                }
            }
            // 处理hash导航到主页solution部分
            else if (menuItem.path === '/#solution') {
                // 如果当前不在主页，先跳转到主页
                if (this.$route.path !== '/') {
                    this.$router.push('/').then(() => {
                        // 等待路由跳转完成后，滚动到solution部分
                        this.$nextTick(() => {
                            this.scrollToSolution();
                        });
                    }).catch(err => {
                        // 忽略重复导航错误
                        if (err.name !== 'NavigationDuplicated') {
                            console.error('路由跳转失败:', err);
                        }
                        // 即使跳转失败，也尝试滚动到solution部分
                        this.scrollToSolution();
                    });
                } else {
                    // 如果已经在主页，直接滚动到solution部分
                    this.scrollToSolution();
                }
            } else {
                // 其他路径使用正常的router-link跳转
                this.$router.push(menuItem.path).catch(err => {
                    // 忽略重复导航错误
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('路由跳转失败:', err);
                    }
                });
            }
        },
        // 滚动到第一屏
        scrollToFirstSection() {
            // 使用事件总线通知Home组件滚动到第一屏
            this.$bus.$emit('scrollToHomeSection', 0); // 0是第一屏的索引
        },
        // 滚动到solution部分
        scrollToSolution() {
            // 获取Home组件的实例来动态计算解决方案轮播项的索引
            this.$nextTick(() => {
                const homeComponent = this.$root.$children.find(child => child.$options.name === 'App')?.$children
                    ?.find(child => child.$options.name === 'HomePage');
                if (homeComponent && homeComponent.getSolutionCarouselIndex) {
                    const solutionIndex = homeComponent.getSolutionCarouselIndex();
                    this.$bus.$emit('scrollToHomeSection', solutionIndex);
                } else {
                    // 如果无法获取动态索引，使用默认值2（适用于没有projectimglist的情况）
                    this.$bus.$emit('scrollToHomeSection', 2);
                }
            });
        },
        // 解析从后端收到的非标准JSON字符串
        parseNonStandardJsonString(jsonString) {
            if (typeof jsonString !== 'string') {
                return jsonString;
            }
            try {
                // 将JS对象写法的字符串修正为标准JSON格式
                // 1. 将键名用双引号包裹： e.g. {key: -> {"key":
                let correctedString = jsonString.replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":');
                // 2. 将值中的单引号替换为双引号： e.g. '/path' -> "/path"
                correctedString = correctedString.replace(/'/g, '"');
                return JSON.parse(correctedString);
            } catch (e) {
                console.error('无法解析后端返回的字符串:', jsonString, e);
                return []; // 返回空数组以防页面崩溃
            }
        },
        // 将驼峰命名转换为下划线命名
        camelToSnake(key) {
            return key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        },
        getAppData() {
            appmanagerapi.getAppData().then(res => {
                let params = res.data.params;
                if (params.menuList) {
                    params.menuList = this.parseNonStandardJsonString(params.menuList);
                }
                // 将API返回的camelCase键名转换为模板使用的snake_case键名
                const snakeCaseParams = {};
                for (const key in params) {
                    // 后端返回的字段是 logo, menuHome...
                    // 前端模板使用的是 logo, menu_home...
                    // 这里做一次转换
                    const snakeKey = this.camelToSnake(key);
                    snakeCaseParams[snakeKey] = params[key];
                }

                // 将处理后的数据赋值给appparams
                this.appparams = { ...this.appparams, ...snakeCaseParams };
            }).catch(error => {
                console.error('获取App数据失败:', error);
            });
        },
        // 获取邮箱数据
        getEmailData() {
            // 先查缓存
            const cachedEmail = this.getCachedEmailData();
            if (cachedEmail) {
                this.emailData = cachedEmail;
                return;
            }

            // 没有缓存直接请求
            aboutmanagerapi.getAboutData().then(res => {
                const params = res.data.params;
                if (params.jobs) {
                    const jobsData = JSON.parse(params.jobs);
                    if (jobsData.email) {
                        this.emailData = jobsData.email;
                        this.cacheEmailData(jobsData.email);
                    }
                }
            }).catch(error => {
                console.error('获取邮箱数据失败:', error);
            });
        },
        // 获取缓存的邮箱数据
        getCachedEmailData() {
            try {
                const cached = localStorage.getItem('emailData');
                if (!cached) return null;
                const { data, timestamp } = JSON.parse(cached);
                const now = Date.now();
                const cacheExpiry = 24 * 60 * 60 * 1000; // 1天
                if (now - timestamp > cacheExpiry) {
                    localStorage.removeItem('emailData');
                    return null;
                }
                return data;
            } catch (e) {
                localStorage.removeItem('emailData');
                return null;
            }
        },
        // 缓存邮箱数据
        cacheEmailData(email) {
            try {
                const cacheData = {
                    data: email,
                    timestamp: Date.now()
                };
                localStorage.setItem('emailData', JSON.stringify(cacheData));
            } catch (e) {
                // 忽略缓存错误
            }
        },
        getUrl(imagePath) {
            if (!imagePath) return '';

            // 如果已经有缓存的URL，直接返回
            if (this.imageUrlCache && this.imageUrlCache[imagePath]) {
                return this.imageUrlCache[imagePath];
            }

            // 初始化缓存对象
            if (!this.imageUrlCache) {
                this.imageUrlCache = {};
            }

            // 发起请求获取URL
            commonapi.getImageUrl(imagePath).then(res => {
                const url = res.data.url;
                // 使用Vue.set确保响应式更新
                this.$set(this.imageUrlCache, imagePath, url);
            }).catch(error => {
                console.error('获取图片URL失败:', error);
                // 缓存空字符串，避免重复请求
                this.$set(this.imageUrlCache, imagePath, '');
            });

            // 返回空字符串，等待异步请求完成后通过响应式更新
            return '';
        }
    },
    created() {
        this.getAppData();
        this.getEmailData();
    }
}
</script>

<style scoped>
.footer-content-top-nav {
    flex-grow: 1;
    text-align: right;
}

.footer-content-top-nav ul {
    display: inline-block;
    vertical-align: top;
    margin-left: 20px;
    text-align: left;
}

.footer-content-top-nav ul:first-child {
    margin-left: 0;
}

.footer-content-top-nav ul a.f1 {
    display: block;
    font-size: 1.3vw;
    color: #fff;
    margin-bottom: 15px;
    text-decoration: none;
    cursor: pointer;
}

.footer-content-top-nav ul li {
    display: block;
}

.footer-content-top-nav ul li a {
    display: block;
    font-size: 1vw;
    color: #999;
    line-height: 1.4vw;
    margin-bottom: 18px;
    transition: all 0.3s;
    text-decoration: none;
    cursor: pointer;
}

.footer-content-top-nav ul li a:last-child {
    margin-bottom: 0;
}

.footer-content-top-nav ul li a:hover {
    color: #fff;
}

.footer-content-top-logo img {
    width: 130px;
}

.footer-content {
    width: 80%;
    margin: auto;
    padding: 2vw;
    position: relative;
}

.footer-content-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.footer-content-top-logo {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.footer-logo-bottom {
    display: flex;
    align-items: center;
    margin-top: 40px;
}

.footer-contact-info {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.footer-content-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
}

.footer-copyright p {
    color: #999;
    font-size: 1vw;
    margin: 0;
}

.footer-qrcode {
    text-align: center;
}

.footer-qrcode img {
    width: 5vw;
    height: 5vw;
}

.footer-qrcode p {
    color: #999;
    font-size: 1vw;
}

.footer-text {
    color: white;
    font-size: 1vw;
}

/* el-collapse 自定义样式 */
.footer-collapse {
    border: none;
}

.footer-collapse>>>.el-collapse-item {
    margin-bottom: 0;
}

.footer-collapse>>>.el-collapse-item__header {
    background-color: transparent;
    border: none;
    border-top: 1px solid #282828;
    color: #fff;
    font-size: 3.5vw;
    line-height: 1.5;
    padding: 10px 0 10px 15px;
    height: auto;
}

.footer-collapse>>>.is-disabled .el-collapse-item__header {
    color: #fff;
    cursor: pointer;
}

.footer-collapse>>>.el-collapse-item__arrow {
    display: none;
}

.footer-collapse>>>.el-collapse-item__wrap {
    background-color: transparent;
    border: none;
}

.footer-collapse>>>.el-collapse-item__content {
    padding: 5px 0 10px 0;
    color: #999;
    background-color: #1c1c1c;
}

.menu-title {
    color: #fff;
    cursor: pointer;
}

.submenu-list {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 15px;
}

.submenu-item {
    color: #fff;
    font-size: 2.5vw;
    line-height: 1.5;
    margin-bottom: 10px;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s;
}

.submenu-item:last-child {
    margin-bottom: 0;
}

.submenu-item:hover {
    color: #fff;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
    .footer-content {
        padding-top: 30px;
        width: 85%;
    }

    .footer-content-top-logo img {
        width: 90px;
    }

    .footer-content-top {
        flex-direction: column;
        align-items: flex-start;
    }

    .footer-content-top-nav {
        text-align: left;
        margin-top: 20px;
        width: 100%;
    }

    .footer-content-top-nav ul {
        display: block;
        margin: 0 0 20px 0;
        text-align: left;
    }

    .footer-content-top-nav ul a.f1 {
        font-size: 3.5vw;
        margin-bottom: 10px;
    }

    .footer-content-top-nav ul li a {
        font-size: 3vw;
        line-height: 4vw;
    }

    .footer-content-bottom {
        flex-direction: row;
        text-align: left;
        justify-content: space-between;
        align-items: center;
    }

    .footer-copyright {
        text-align: left;
        flex: 1;
    }

    .footer-logo-bottom {
        display: none;
    }

    .footer-contact-info {
        margin-left: 0;
        margin-top: 10px;
    }

    .footer-qrcode {
        margin-top: 0;
        margin-left: 0;
    }

    .footer-copyright p {
        font-size: 3vw;
        margin-bottom: 0;
    }

    .footer-qrcode img {
        width: 60px;
        height: 60px;
    }

    .footer-qrcode p {
        font-size: 3vw;
    }

    .footer-text {
        color: white;
        font-size: 12px;
    }

    /* 移动端版权信息样式 */
    .footer-content-bottom-mobile {
        margin-top: 20px;
        text-align: center;
    }

    .footer-content-bottom-mobile .footer-copyright p {
        color: #999;
        font-size: 2.5vw;
        margin: 0;
    }
}
</style>